import classNames from 'classnames';

import lang from '../../lib/language';

import { useIsMobile } from '../../hooks';
import NavButtons from '../NavigationButtons/NavButtons';

import FavouritesWatchList from './WatchListTable/FavouritesWatchList';
import PopularWatchList from './WatchListTable/PopularWatchList';

import styles from './WatchList.module.scss';

const WatchList = () => {
  const { isMobile } = useIsMobile();

  const tabs = [
    { text: lang.mobileWatchlistStocks(), component: <PopularWatchList /> },
    { text: lang.commonFavourites(), component: <FavouritesWatchList /> },
  ];

  return (
    <div className={styles.container}>
      <div
        className={
          isMobile // eslint-disable-line no-nested-ternary
            ? classNames(styles.navigationWrapperMobile, styles.noMargin)
            : styles.table
        }
      >
        <NavButtons isWatchlist tabs={tabs} />
      </div>
    </div>
  );
};

export default WatchList;
